import React, { createContext, useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { useImmer } from "use-immer";
import CodingEventService from '../services/CodingEventService';
import { applicationContextActionCreator, modalActionCreator } from '../store/actions/';
import { queryFilters } from "../store/initStates";
import _ from 'lodash';

export const CodingEventQueueContext = createContext();
export const CodingEventQueueConsumer = CodingEventQueueContext.Consumer;

const CodingEventQueueContextProvider = (props) => {
    const filterComparison = (a, b) => {
        const changed = !_.isEqual(a, b);
        return changed;
    }

    const filterSelector = useSelector(state => state.applicationContext.filters.codingEventsFilters, filterComparison);
    //const [filterSelector, setFilterSelector] = useImmer();
    const [codingEvents, setCodingEvents] = useImmer([]);
    const [refData, setRefData] = useImmer({
        statusRefData: [],
        assignedToRefData: [],
        queueRefData: [],
        customerRefData: [],
        eventPriorityRefData: [],
        caseOriginsRefData: [],
        lineOfBusinessRefData: [],
        requestedServiceRefData: [],
        totalRecords: 0
    });

    const [filterType, setFilterType] = useImmer('');

    const dispatch = useDispatch();
    const [selectedEvents, setSelectedEvents] = useImmer([]);
    const [origSelectedEvents, setOrigSelectedEvents] = useImmer([]);
    const [editMode, setEditMode] = useState(false);
    const [filters, setFilters] = useImmer(null);
    const [filtered, setFiltered] = useImmer(false);

    useEffect(() => {
        console.log("Rendering CodingEventQueueContext")
    }, [])

    const getCodingEvents = async () => {
        //const filters = filterSelector[filterType];
        if (filters !== null) {
            var service = new CodingEventService();
            var callResult = await service.getEvents(filters);

            if (callResult.result) {
                if (filters.fetchRefData) {
                    //vm = callResult.model;
                    setRefData(_.omit(callResult.model, 'codingEvents'));
                }

                setCodingEvents(callResult.model.codingEvents);

            } else {
                // do error handling
            }
        }
    }

    useEffect(() => {
        setSelectedEvents([]);
        return () => {
            console.log("cleanup editMode useEffect");
        };
    }, [editMode]);

    useEffect(() => {
        
        const localFilters = filterType && filterSelector[filterType];
        if (filterComparison(localFilters, filters)) {
            localFilters && setFilters(localFilters);
        }
        return () => {
            console.log("cleanup filterType useEffect");
        };
    }, [filterType]);

    useEffect(() => {
        filters &&
        dispatch(applicationContextActionCreator.updateCodingEventQueueFilters({
            "filterType": filterType,
            "filters": filters
        })).then(() => {
            let initFilters = queryFilters.codingEventsFilters[filterType];
            const diff = filterComparison(filters, initFilters);
            let filterDiff = filters && initFilters && diff;
            setFiltered(filterDiff);
            filters && getCodingEvents();
        });
        return () => {
            console.log("cleanup filters useEffect");
        };
    }, [filters]);

    const showModal = (props, type) => {
        dispatch(modalActionCreator.showModal(props, type));
    }

    const hideModal = () => {
        dispatch(modalActionCreator.hideModal());
    }

    const setFilterValue = (name, value) => {
        setFilters(draft => {
            draft[name] = value;
            draft.currentPage = 0;
            draft.skip = 0;
        });
    }

    const clearSelectedEvents = () => {
        setSelectedEvents([]);
    }

    const updateSelectedEvents = async (events) => {

        const ev = events;
        if (ev.length > 0) {
            const service = new CodingEventService();
            var callResult = await service.bulkSaveEvents({ "events": events });
            if (callResult.result) {
                setCodingEvents(draft => {
                    callResult.model.forEach((event, i) => {
                        //var index = draft.map(e => e.id).indexOf(event.id);
                        var index = draft.findIndex(e => e.id === event.id);
                        draft[index] = event;
                    });
                });
                clearSelectedEvents();
                return true;
            } else {
                return false;
            }
        }
    }

    const editSelected = () => {
        let editSelectedEvents = _.cloneDeep(selectedEvents);
        showModal({
            open: true,
            size: "xxl",
            hideModal: hideModal,
            editEvents: editSelectedEvents,
            refData: refData,
            filters: filters,
            updateSelectedEvents: updateSelectedEvents
        }, 'bulkEditEventsModal');
    }

    // reset filters to the initial state
    const resetFilters = () => {
        let initFilters = queryFilters.codingEventsFilters[filterType];
        setFilters(initFilters);
    }

    const pageResults = (newPage) => {
        setFilters(draft => {
            draft.currentPage = newPage;
            draft.skip = newPage * draft.take;
        })
    }

    const selectEvent = (event) => {
        setSelectedEvents(draft => {
            var index = draft.indexOf(event);
            if (index !== -1) {
                draft.splice(index, 1);
            } else {
                draft.push(event);
            }
        });
    }
    return (
        <CodingEventQueueContext.Provider value={{
            codingEvents,
            filters,
            setFilterValue,
            //setAllFilters,
            setFilterType,
            resetFilters,
            filtered,
            pageResults,
            refData,
            editMode,
            setEditMode,
            selectedEvents,
            selectEvent,
            editSelected,
            clearSelectedEvents,
            setSelectedEvents,
            getCodingEvents
        }}>
            {props.children}
        </CodingEventQueueContext.Provider >
    )
}

export default CodingEventQueueContextProvider;